module.exports = __webpack_public_path__ + "static/media/cross.e8d50e1e.svg";